import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListCabRequests from "../Components/Cab Requests/listRequest";
import AddCabCategory from "../Components/Cab Requests/addCabCategory";
import ViewCabSetting from "../Components/Cab Requests/viewCabSetting";
import EditCabCategory from "../Components/Cab Requests/editCabSetting";


const CabSettingRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route
        path="/cab_settings"
        element={<ListCabRequests></ListCabRequests>}
      ></Route>
      <Route
        path="/cab_settings/add"
        element={canAdd ? <AddCabCategory></AddCabCategory> : <Navigate to="/cab_settings" replace />}
      ></Route>
      <Route
        path="/cab_settings/view/:id"
        element={<ViewCabSetting></ViewCabSetting>}
      ></Route>
      <Route
        path="/cab_settings/edit/:id"
        element={<EditCabCategory></EditCabCategory>}
      ></Route>
    </Routes>
  );
};

export default CabSettingRoutes;
